import React, { PropsWithChildren, useRef, useState } from "react";
import { useOutsideClickDetection } from "../../../../lib/hooks/useOutsideClickDetection";

import { DropdownList } from "../../../shared/DropdownList/DropdownList";
import { Icon } from "../../../shared/Icon/Icon";

const options = [
  {
    icon: "edit-icon",
    label: "Edit",
    type: "edit",
  },
  {
    icon: "delete-default",
    label: "Delete",
    type: "delete",
  },
];

export const GroupActionList = ({
  handleDeleteGroup,
  handleEditGroup,
}: PropsWithChildren<{
  id: string;
  name: string;
  handleDeleteGroup: () => Promise<void>;
  handleEditGroup: () => void;
}>) => {
  const ref = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useOutsideClickDetection(
    ref,
    () => {
      if (showDropdown) {
        setShowDropdown(false);
      }
    },
    showDropdown
  );

  const handleClickOption = (type: string) => {
    if (type === "delete") {
      return handleDeleteGroup();
    }

    if (type === "edit") {
      return handleEditGroup();
    }
  };

  return (
    <div
      ref={ref}
      className="GroupActionList"
      onClick={() => setShowDropdown((prev) => !prev)}
    >
      <div>
        <Icon icon="actions-icon" />
      </div>

      {showDropdown && (
        <DropdownList
          extended
          color="gray"
          options={options}
          onClick={(value) => handleClickOption(value)}
        />
      )}
    </div>
  );
};
